import * as auditApi from "@hub/audit/src/api/audit.api"
import createErrorMessage from "@shared/factories/src/errorMessage.factory"

export const fetchAuditableOrder = async () => {
  try {
    return await auditApi.fetchAuditableOrder()
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao obter dados do pedido."
    })
    throw error
  }
}

export const fetchAuditableOrderByUuid = async (payload) => {
  try {
    return await auditApi.fetchAuditableOrderByUuid(payload)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao obter dados do pedido."
    })
    throw error
  }
}

export const fetchViewOrderByUuid = async (payload) => {
  try {
    return await auditApi.fetchViewOrderByUuid(payload)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao obter dados do pedido."
    })
    throw error
  }
}

export const fetchBiometricData = async (uuid) => {
  try {
    return await auditApi.fetchBiometricData(uuid)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao obter dados da biometria."
    })
  }
}

export const resendBiometry = async (uuid, payload) => {
  try {
    const { data } = await auditApi.resendBiometry(uuid, payload)
    return data
  } catch (error) {
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao reenviar biometria."
    })
  }
}

export const updateBiometryStatus = async (uuid, payload) => {
  try {
    return await auditApi.updateBiometryStatus(uuid, payload)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao atualizar status da biometria."
    })
    throw error
  }
}

export const editAuditorshipData = async (uuid, payload) => {
  try {
    return await auditApi.editAuditorshipData(uuid, payload)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao editar os dados do pedido."
    })
    throw error
  }
}

export const editFinishedOrder = async (uuid, payload) => {
  try {
    return await auditApi.editFinishedOrder(uuid, payload)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao editar o pedido finalizado."
    })
    throw error
  }
}

export const setPendency = async (uuid, payload) => {
  try {
    return await auditApi.setPendency(uuid, payload)
  } catch (error) {
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao pendenciar pedido."
    })
    throw error
  }
}

export const saveNote = async (uuid, payload) => {
  try {
    const { data } = await auditApi.saveNote(uuid, payload)
    window.$vue.$toast({
      type: "success",
      title: "Observação salva com sucesso!"
    })
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao salvar observação."
    })
  }
}

export const finishAuditorship = async (uuid, payload) => {
  try {
    const data = await auditApi.finishAuditorship(uuid, payload)

    window.$vue.$toast({
      type: "success",
      title: "Pedido salvo com sucesso!"
    })

    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao salvar pedido."
    })
    throw error
  }
}

export const fetchStatusCoverageAuditorship = async (uuid) => {
  try {
    return await auditApi.fetchStatusCoverageAuditorship(uuid)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao obter análise de cobertura."
    })
  }
}

export const fetchStatusCreditAuditorship = async (uuid, payload) => {
  try {
    return await auditApi.fetchStatusCreditAuditorship(uuid, payload)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha na análise de crédito!"
    })
    throw error
  }
}

export const fetchCancelReasons = async (params) => {
  try {
    const { data } = await auditApi.fetchCancelReasons(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao obter motivos de cancelamento."
    })
    throw error
  }
}

export const listProfessions = async () => {
  try {
    return await auditApi.listProfessions()
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Erro ao obter lista de profissões."
    })
  }
}

export const fetchCreditAnalysisInformationPerSale = async (uuid) => {
  try {
    return await auditApi.fetchCreditAnalysisInformationPerSale(uuid)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao obter análise de crédito."
    })
  }
}

export const exportOrder = async (uuid) => {
  try {
    return await auditApi.exportOrder(uuid)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha exportar pedido."
    })
  }
}

export const listStatusReasons = async (params) => {
  try {
    const { data } = await auditApi.listStatusReasons(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao listar motivos."
    })
  }
}

export const checkEmail = async (params) => {
  try {
    const { data } = await auditApi.checkEmail(params)
    return data.status
  } catch (error) {
    console.error(error)
    return true
  }
}

export const getTermsOfUse = async (uuid) => {
  try {
    const { data } = await auditApi.getTermsOfUse(uuid)
    return data
  } catch (error) {
    console.error(error)
    return true
  }
}

export const finishIntegrationSale = async (payload, uuid) => {
  try {
    const { data } = await auditApi.finishIntegrationSale(payload, uuid)
    window.$vue.$toast({
      type: "success",
      title: "Pedido em integração finalizado com sucesso!"
    })

    return data
  } catch (error) {
    window.$vue.$toast({
      type: "error",
      title:
        error?.data?.message ||
        createErrorMessage(error).getMessage() ||
        "Falha ao finalizar pedido em integração"
    })
    console.error(error)
  }
}

export const fetchNoteType = async () => {
  try {
    const { data } = await auditApi.listNoteType()
    return data
  } catch (error) {
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao listar pendências."
    })
  }
}

export const listServicesStatus = async () => {
  try {
    const { data } = await auditApi.listServicesStatus()
    return data
  } catch (error) {
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao listar os status do serviço"
    })
  }
}

export const fetchCoverageDetail = async (uuid) => {
  try {
    return await auditApi.fetchCoverageDetail(uuid)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao obter detalhes da cobertura."
    })
  }
}

export const fetchBiometryReasons = async () => {
  try {
    return await auditApi.fetchBiometryReasons()
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao obter motivos de reprovação."
    })
  }
}

export const fetchStatusNoteType = async () => {
  try {
    const { data } = await auditApi.fetchStatusNoteType()
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao obter tipos de status."
    })
  }
}

export const updateStatus = async (data) => {
  try {
    return await auditApi.updateStatus(data)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.error ||
        createErrorMessage(error).getMessage() ||
        "Falha ao atualizar status."
    })
  }
}

export const fetchCreditAnalysisDetails = async (payload) => {
  try {
    return await auditApi.fetchCreditAnalysisDetails(payload)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao obter detalhes da análise de crédito."
    })
    return null
  }
}

export const fetchOrderCommissions = async (uuid) => {
  try {
    const { data } = await auditApi.fetchOrderCommissions(uuid)
    return data
  } catch (error) {
    console.error(error)
    return null
  }
}
